import * as React from "react";
import { observer } from "mobx-react";
import { useStore } from "../../App";
import { Stat, StatLabel, StatNumber, StatHelpText, StatArrow, Box, Flex } from "@chakra-ui/core";
import { styled } from "../../ui/theme";
import useComponentSize from "../../hook/useComponentSize";
import MiniChart from "./MiniChart";

export default observer(function Sterkte() {
  const ref = React.useRef<HTMLDivElement>(null);
  const size = useComponentSize(ref);
  const store = useStore();
  const inc = store.deaths.deltaP >= 0;
  return (
    <Container ref={ref}>
      {size.width > 0 && <MiniChart data={store.deaths.deltasP} width={size.width} height={size.height} />}
      <article>
        <Flex alignItems="center">
          <Stat mr={0} pr={0}>
            <StatLabel>Overleden</StatLabel>
            <StatNumber>{store.deaths.total}</StatNumber>
            <StatHelpText>
              <StatArrow type={inc ? "increase" : "decrease"} color={inc ? "red.400" : "green.400"} />
              {store.deaths.deltaP}% ({store.deaths.delta})
            </StatHelpText>
          </Stat>
        </Flex>
      </article>
    </Container>
  );
});

const Container = styled.div`
  flex-grow: 1;
  max-width: 100%;
  overflow: hidden;
  position: relative;

  article {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: stretch;
    justify-content: space-around;
  }
`;
